export function showPopups(response, handlers = {}) {
    const popup =
        response?.info_alert
    if (!popup) return false;
    handlers.setPopupData?.(popup);
    handlers.setShowPopup?.(true);
    return true;
}
